import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../features/admin/courses/studyprogram/Slice";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../../../../../utils/IDS";
import {
  allCareerRequirement,
  allCourse,
  allEligibilityReqirement,
  allProgramHighlight,
  allRequiredDocument,
  AllUniversity,
} from "../../../../../../../features/admin/common/Slice";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
  image_required = true,
  logo_required = true,
  country_logo_required = true,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });

  const countries = useSelector((state) => state.common.all_university);
  const courses = useSelector((state) => state.common.all_course);
  const allprogramhighlight = useSelector(
    (state) => state.common.all_program_highlight
  );
  const alleligibilityrequirement = useSelector(
    (state) => state.common.all_eligibility_requirement
  );
  const allcareerrequirement = useSelector(
    (state) => state.common.all_career_requirement
  );
  const allrequirementdocument = useSelector(
    (state) => state.common.all_requirement_document
  );

  useEffect(() => {
    dispatch(AllUniversity());
    dispatch(allCourse());
    dispatch(allProgramHighlight());
    dispatch(allEligibilityReqirement());
    dispatch(allCareerRequirement());
    dispatch(allRequiredDocument());
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("university_id", data.university_id.value);
      sendData.append("course_id", data.course_id.value);
      sendData.append("application_fees", data.application_fees);
      sendData.append("tution_fees", data.tution_fees);
      sendData.append("application_deadline", data.application_deadline);
      sendData.append("accomodation", data.accomodation === "true");

      sendData.append(
        "program_highlights",
        JSON.stringify(data.program_highlights.map((i) => i.value))
      );
      sendData.append(
        "program_eligibilities",
        JSON.stringify(data.program_eligibilities.map((i) => i.value))
      );
      sendData.append(
        "program_careers",
        JSON.stringify(data.program_careers.map((i) => i.value))
      );
      sendData.append(
        "program_documents",
        JSON.stringify(data.program_documents.map((i) => i.value))
      );

      const res = await dispatch(Update({ id: show, data: sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());
        setModalsuccessShow(true); // ✅ success popup
      } else {
        setShowRejectModal(true); // ❌ error popup
      }
    } catch (error) {
      console.error(error);
      setShowRejectModal(true); // ❌ error popup
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
        handleClose(); // close offcanvas
        setSuccess(true); // parent success (refresh / toast)
      }, 3000); // ⏱️ 3 seconds

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow, handleClose, setSuccess]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));

      if (res?.payload?.data) {
        const d = res.payload.data;

        reset({
          university_id: d.university_id,
          course_id: d.course_id,
          accomodation: d.accomodation ? "true" : "false",

          program_highlights: allprogramhighlight.filter((opt) =>
            d.program_highlights.includes(String(opt.value))
          ),

          program_eligibilities: alleligibilityrequirement.filter((opt) =>
            d.program_eligibilities.includes(String(opt.value))
          ),

          program_careers: allcareerrequirement.filter((opt) =>
            d.program_careers.includes(String(opt.value))
          ),

          program_documents: allrequirementdocument.filter((opt) =>
            d.program_documents.includes(String(opt.value))
          ),

          application_fees: d.application_fees,
          tution_fees: d.tution_fees,
          application_deadline: d.application_deadline?.slice(0, 10),
        });
      }
    } catch (error) {
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>University </Form.Label>
                    <Controller
                      name="university_id"
                      control={control}
                      rules={{ required: "University is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={countries}
                          onInputChange={(val) => {
                            dispatch(AllUniversity(val));
                          }}
                        />
                      )}
                    />
                    {errors?.university_id && (
                      <Form.Text className="text-danger">
                        {errors?.university_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Course</Form.Label>
                    <Controller
                      name="course_id"
                      control={control}
                      rules={{ required: "Course is required" }}
                      render={({ field }) => {
                        const universityId = getValues("university_id");
                        const isCountrySelected = Boolean(universityId?.value);
                        return (
                          <Select
                            {...field}
                            options={isCountrySelected ? courses : []}
                            // isDisabled={!isCountrySelected}
                            onInputChange={(val) => {
                              if (isCountrySelected) {
                                dispatch(
                                  allCourse({
                                    universityId: universityId.value,
                                    name: val,
                                  })
                                );
                              }
                            }}
                          />
                        );
                      }}
                    />
                    {errors?.state_id && (
                      <Form.Text className="text-danger">
                        {errors?.state_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Program Highlight </Form.Label>
                    <Controller
                      name="program_highlights"
                      control={control}
                      rules={{ required: "Program Highlight is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={allprogramhighlight}
                          isMulti
                        />
                      )}
                    />

                    {errors?.program_highlight_id && (
                      <Form.Text className="text-danger">
                        {errors?.program_highlight_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Eligibility Requirement </Form.Label>
                    <Controller
                      name="program_eligibilities"
                      control={control}
                      rules={{
                        required: "Eligibility Requirement is required",
                      }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={alleligibilityrequirement}
                          isMulti
                        />
                      )}
                    />

                    {errors?.eligibility_requirement_id && (
                      <Form.Text className="text-danger">
                        {errors?.eligibility_requirement_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Career Requirement </Form.Label>
                    <Controller
                      name="program_careers"
                      control={control}
                      rules={{ required: "Career Requirement is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={allcareerrequirement}
                          isMulti
                        />
                      )}
                    />

                    {errors?.career_requirement_id && (
                      <Form.Text className="text-danger">
                        {errors?.career_requirement_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Requirement Document</Form.Label>
                    <Controller
                      name="program_documents"
                      control={control}
                      rules={{ required: "Requirement Document is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={allrequirementdocument}
                          isMulti
                        />
                      )}
                    />

                    {errors?.requirement_document_id && (
                      <Form.Text className="text-danger">
                        {errors?.requirement_document_id?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Application Fees</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Application Fees"
                      min="0"
                      className={classNames({
                        "is-invalid": errors?.application_fees,
                      })}
                      {...register("application_fees", {
                        required: "Application Fees is required",
                        min: {
                          value: 0,
                          message: "Application Feess cannot be negative",
                        },
                      })}
                    />
                    {errors?.application_fees && (
                      <Form.Text className="text-danger">
                        {errors.application_fees.message}
                      </Form.Text>
                    )}
                  </Form.Group>{" "}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Tuition Fees</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Enter Tuition Fees"
                      min="0"
                      className={classNames({
                        "is-invalid": errors?.tution_fees,
                      })}
                      {...register("tution_fees", {
                        required: "Tuition Fees is required",
                        min: {
                          value: 0,
                          message: "Tuition Feess cannot be negative",
                        },
                      })}
                    />
                    {errors?.tution_fees && (
                      <Form.Text className="text-danger">
                        {errors.tution_fees.message}
                      </Form.Text>
                    )}
                  </Form.Group>{" "}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Application Deadline</Form.Label>
                    <Form.Control
                      type="date"
                      placeholder="Enter Application Deadline Date (yyyy-mm-dd)"
                      {...register("application_deadline", {
                        required: "Application Deadline date is required",
                        validate: (value) => {
                          if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                            return "Date must be in yyyy-mm-dd format";
                          }
                          const year = value.split("-")[0];
                          if (year.length !== 4) {
                            return "Year must be exactly 4 digits";
                          }
                          const yearNum = parseInt(year);
                          const currentYear = new Date().getFullYear();
                          if (yearNum < 1900 || yearNum > currentYear) {
                            return `Year must be between 1900 and ${currentYear}`;
                          }
                          const date = new Date(value);
                          if (isNaN(date.getTime())) {
                            return "Invalid date";
                          }
                          return true;
                        },
                      })}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value) {
                          const year = value.split("-")[0];
                          if (year.length > 4) {
                            e.target.value = value.slice(0, 4) + value.slice(5);
                          }
                        }
                      }}
                    />
                    {errors?.application_deadline && (
                      <Form.Text className="text-danger">
                        {errors.application_deadline.message}
                      </Form.Text>
                    )}
                  </Form.Group>{" "}
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Accommodation Available</Form.Label>

                    <div className="d-flex gap-4">
                      <Form.Check
                        type="radio"
                        label="Yes"
                        value="true"
                        {...register("accomodation", {
                          required: "Accommodation selection is required",
                        })}
                      />

                      <Form.Check
                        type="radio"
                        label="No"
                        value="false"
                        {...register("accomodation")}
                      />
                    </div>

                    {errors?.accomodation && (
                      <Form.Text className="text-danger">
                        {errors.accomodation.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
